module.exports = __webpack_public_path__ + "static/img/baserecord.f2505615.png";